import React, { FC } from "react";
import clsx from "clsx";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 5,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#0676ed",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#0676ed",
    },
  },
  label: {
    userSelect: "none",
  },
  disabledLabel: {
    userSelect: "none",
    "& > .MuiFormControlLabel-label": {
      color: "#a1a4ac",
    },
  },
  labelWithError: {
    "& > .MuiFormControlLabel-label": {
      color: theme.palette.error.main,
    },
  },
}));

const WeduCheckbox: FC<any> = (props) => {
  const classes = useStyles();

  const {
    input: { checked, value, name, onChange, disabled, ...restInput },
    meta,
    label,
    hasError,
    ...rest
  } = props;

  return (
    <FormControlLabel
      className={clsx(
        disabled ? classes.disabledLabel : classes.label,
        !disabled && hasError && classes.labelWithError,
      )}
      label={props.label}
      control={
        <Checkbox
          name={name}
          inputProps={restInput}
          onChange={onChange}
          checked={checked}
          value={value}
          className={classes.root}
          disabled={disabled}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          // inputProps={{'aria-label': 'decorative checkbox'}}
          {...rest}
        />
      }
    />
  );
};

export default WeduCheckbox;
